var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-unknown"},[_c('MessageText',{attrs:{"message":{
            content: _vm.$translate('MTYPE_UNKNOWN'),
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }